import { createAction, props } from '@ngrx/store';
import { Contract } from 'src/app/pages/orders/interfaces/contracts.interface';

export const loadContractsByJobsite = createAction('[ContractsByJobsite] Load', props<{ jobsiteId: number }>());
export const loadContractsByJobsiteSuccess = createAction(
  '[ContractsByJobsite] Load Success',
  props<{ response: Contract[] }>(),
);
export const loadContractsByJobsiteFailure = createAction('[ContractsByJobsite] Load Failure', props<{ error: any }>());
export const loadContractsByJobsiteSuccessByKey = createAction(
  '[ContractsByJobsite] Load Success By Key',
  props<{ key: string; response: Contract[] }>(),
);
